<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        {{ $t('Filters') }}
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <!-- <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>{{ $t('Parent') }}</label>
          <b-form-select
            v-model="departmentFilterLocal"
            @change="refetchData"
          >
            <option
              v-for="option in departmentOptions"
              :key="option.value"
              :value="option.value"
              :class="{ 'font-weight-bolder': option.level === 1 || option.level === 2 }"
            >
              {{ option.text }}
            </option>
          </b-form-select>
        </b-col> -->
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Tìm kiếm</label>
          <b-input-group>
            <b-form-input
              v-model="localSearchQuery"
              class="d-inline-block"
              placeholder="Nhập từ khóa"
              @keyup.enter="updateSearchQuery"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                @click="updateSearchQuery"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>

        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Là phòng giám đốc</label>
          <b-form-select
            v-model="departmentFilterIsDirector"
            @change="refetchData"
          >
            <option
              v-for="option in [{ value: null, text: 'Tất cả' }, { value: '0', text: 'Không' }, { value: '1', text: 'Có' }]"
              :key="option.value"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </b-form-select>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BButton, BFormSelect, BFormSelectOption,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormSelect,
    BFormSelectOption,
    vSelect,
  },
  props: {
    departmentFilter: {
      type: [Number, null],
      default: null,
    },
    statusFilter: {
      type: [Number, null],
      default: null,
    },
    searchQuery: {
      type: [String, null],
      default: null,
    },
    departmentOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      departmentFilterIsDirector: null,
    }
  },
  setup(props, { emit }) {
    const localSearchQuery = ref('')
    // const { departmentOptions } = useDepartments();

    const updateSearchQuery = () => {
      emit('update:searchQuery', localSearchQuery.value)
    }

    return {
      localSearchQuery,
      updateSearchQuery,
    };
  },
  methods: {
    refetchData() {
      this.$emit('update:departmentFilterIsDirector', this.departmentFilterIsDirector)
    },
  },

}
</script>

<style lang="scss">
// @import '@core/scss/vue/libs/vue-select.scss';

.option-bold {
  font-weight: 600;
}
</style>
